import React from 'react';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { Hero } from './components/sections/Hero';
import { BrandPhrase } from './components/sections/BrandPhrase';
import { Problem } from './components/sections/Problem';
import { Masterclass } from './components/sections/Masterclass';
import { Discover } from './components/sections/Discover';
import { Method } from './components/sections/Method';
import { About } from './components/sections/About';
import { DiscoveryCall } from './components/sections/DiscoveryCall';
import { Process } from './components/sections/Process';
import { Closing } from './components/sections/Closing';
export function App() {
  return <div className="min-h-screen flex flex-col bg-brand-cream selection:bg-brand-sage selection:text-brand-ink" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <BrandPhrase data-id="element-4" />
        <Problem data-id="element-5" />
        <Masterclass data-id="element-6" />
        <Discover data-id="element-7" />
        <Method data-id="element-8" />
        <About data-id="element-9" />
        <DiscoveryCall data-id="element-10" />
        <Process data-id="element-11" />
        <Closing data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}